const CHECK_FWU_AVAILABILITY = 'CHECK_FWU_AVAILABILITY';

const DEVICE_STATUS_NOT_UPDATED = 'DEVICE_STATUS_NOT_UPDATED';
const DEVICE_DISCONNECTED = 'DEVICE_DISCONNECTED';
const DEVICE_ASSETS_NOT_UPDATED = 'DEVICE_ASSETS_NOT_UPDATED';
const LOW_BATTERY = 'LOW_BATTERY';

const PRECONDITIONS = [DEVICE_STATUS_NOT_UPDATED, DEVICE_DISCONNECTED, DEVICE_ASSETS_NOT_UPDATED, LOW_BATTERY];

export default {
    DEVICE_STATUS_NOT_UPDATED,
    DEVICE_DISCONNECTED,
    DEVICE_ASSETS_NOT_UPDATED,
    LOW_BATTERY,
    PRECONDITIONS,
    CHECK_FWU_AVAILABILITY,
};
